/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { CreateSession1MutationRequest, CreateSession1MutationResponse, CreateSession1400, CreateSession1401, CreateSession1404, CreateSession1409, CreateSession1500 } from "../../types/CreateSession1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getCreateSession1Url() {
  const res = { method: 'POST', url: `/api/research-chat` as const }
  return res
}

/**
 * @summary Create new research chat session
 * {@link /api/research-chat}
 */
export async function createSession1(data: CreateSession1MutationRequest, config: Partial<RequestConfig<CreateSession1MutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateSession1MutationResponse, ResponseErrorConfig<CreateSession1400 | CreateSession1401 | CreateSession1404 | CreateSession1409 | CreateSession1500>, CreateSession1MutationRequest>({ method : "POST", url : getCreateSession1Url().url.toString(), data : requestData, ... requestConfig })
  return res.data
}